/*!
 *  (c)(r) 2008-2023 IT-Service Robert Frunzke
 */

import { MDLocaleBase } from './locale-base.js';

const MDLocale = MDLocaleBase.get_impl();

export {
	MDLocale
};
